import { FC } from 'react'

import { useParams } from 'react-router-dom'

import { useRedirectFailedCheckout } from 'src/Hooks/useRedirectFailedCheckout'
import { useTikTokCampaignMinBudgetExperiment } from 'src/Hooks/Experiments/useTikTokCampaignMinBudgetExperiment'
import {
  PrimaryScheduleSteps,
  PrimaryScheduleTabs,
  ScheduleSteps,
} from 'src/Components/PrimaryScheduleTabs'
import { useScheduleTikTokCampaign } from 'src/Pages/Artist/TiktokSchedulePage/helpers/useSchaduleTikTokCampaign'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { ScheduleSuccessPage } from 'src/Components/ScheduleSuccessPage'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { useAppSelector } from 'src/Hooks/redux'
import { OrderCheckoutRecoveryModal } from 'src/Pages/Artist/SpotifySchedulePage/OrderCheckoutRecoveryModal'

import { TiktokScheduleOrderCheckoutPage } from './TiktokScheduleOrderCheckoutPage'
import { TiktokScheduleSettingsPage } from './TiktokScheduleSettingsPage'

export const TiktokSchedulePage: FC = () => {
  useRedirectFailedCheckout()
  const { number } = useParams()

  useScheduleTikTokCampaign()
  useTikTokCampaignMinBudgetExperiment()

  const scheduledCampaign = useAppSelector(getScheduledTikTokCampaign)
  const steps: PrimaryScheduleSteps[] = [
    {
      title: 'Campaigns',
      path: ArtistRoutesEnum.CampaignsList,
    },
    {
      title: 'Campaign settings',
      path: `${ArtistRoutesEnum.TiktokSchedule}/${number}?step=${ScheduleSteps.SETTINGS}`,
    },
    {
      title: 'Checkout',
      path: `${ArtistRoutesEnum.TiktokSchedule}/${number}?step=${ScheduleSteps.CHECKOUT}`,
    },
  ]

  return (
    <>
      <OrderCheckoutRecoveryModal />
      <ScheduleSuccessPage
        startDate={scheduledCampaign.startDate}
        platformName={CampaignPlatformTypeEnum.TIKTOK}
      />
      <PrimaryScheduleTabs steps={steps}>
        {/* first must be settings second checkout */}
        <TiktokScheduleSettingsPage />
        <TiktokScheduleOrderCheckoutPage />
      </PrimaryScheduleTabs>
    </>
  )
}
